import { Inject } from "inversify-props";
import type { PromocaoServiceAdapter } from "./adapter/PromocaoServiceAdapter";
import { AxiosRequestConfig } from "axios";
import { ItemDaVenda, Page, Promocao } from "@/models";

export class FindPromocaoUseCase{
	@Inject('PromocaoServiceAdapter')
		private promocaoServiceAdapter!: PromocaoServiceAdapter

	findPagePromocoes = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Promocao>> =>
		await this.promocaoServiceAdapter.findPagePromocoes(params, config)

	findDescontosProgressivosAplicaveisNaVenda = async (lojaId: any, cpfOuCnpjCliente: string, itens: ItemDaVenda[], valorTotalLiquidoDosItens: any): Promise<Promocao[]> =>
		await this.promocaoServiceAdapter.findDescontosProgressivosAplicaveisNaVenda(lojaId, cpfOuCnpjCliente, itens, valorTotalLiquidoDosItens)

	validarItensDaVendaParaPromocao = async (promocaoId: any, itens: ItemDaVenda[]): Promise<string[]> =>
		await this.promocaoServiceAdapter.validarItensDaVendaParaPromocao(promocaoId, itens)
}